export default "__VITE_ASSET__CxhhCV0S__"